<script lang="ts">
    /**
     * GuideSection - Section 5: 사용자 가이드
     *
     * 아코디언 형식 가이드 + FAQ
     */

    let openIndex = $state<number | null>(null);

    function toggle(index: number) {
        openIndex = openIndex === index ? null : index;
    }

    const guides = [
        {
            title: '처음 시작하기 (Quick Start)',
            content: '1. 앱 다운로드 → Google/Apple 계정으로 간편 로그인\n2. 기본 정보 입력 (키, 체중, 목표)\n3. 스마트워치 연동 (선택)\n4. 첫 번째 챌린지에 참여하기!',
        },
        {
            title: '근거리 협동 챌린지 사용법',
            content: '1. CHALLENGE 탭에서 "근거리 챌린지" 선택\n2. 호스트(방 만들기) 또는 참가자(참여하기) 선택\n3. 챌린지 타입과 목표 설정\n4. 참가자는 근처에서 방을 연 호스트를 목록에서 골라 참가\n5. 대기실에서 전원 준비 완료 → 호스트가 시작!\n6. 실시간으로 진행률 확인하며 목표 달성!\n7. 끝나면 최종 순위 확인',
        },
        {
            title: '건강 데이터 연동',
            content: '지원 플랫폼:\n- Google Fit (Android)\n- Samsung Health (Galaxy 기기)\n- Apple Health (iOS)\n- 스마트워치 직접 연동 (Galaxy Watch, Apple Watch)\n\n설정 → 연동 서비스에서 원하는 플랫폼을 연결하세요.\n자동으로 걸음수, 심박수, 운동 기록이 동기화됩니다.',
        },
        {
            title: 'AI 건강 분석 시스템',
            content: 'SMART 탭에서 8가지 AI 분석을 이용할 수 있습니다:\n\n기본 분석 (베이직 이상 무료):\n- 건강 분석 — 전반적 건강 상태 AI 분석\n- 활동 분석 — 운동/활동 패턴 분석\n- 운동 추천 — 맞춤형 운동 루틴 추천\n\n영양 분석 (프로 이상 무료):\n- 식단 추천, 영양 분석\n\n프리미엄 분석:\n- 종합 리포트, 코호트 비교, 목표 예측\n\n무료 플랜에서도 크레딧으로 모든 AI 분석 이용 가능!',
        },
    ];

    const faqs = [
        { q: '제이드아이는 무료인가요?', a: '네! 기본 기능(운동 기록, 챌린지, 커뮤니티 등)은 모두 무료입니다. AI 분석 기능은 크레딧이 필요하며, 무료 플랜에서도 월 10 크레딧이 제공됩니다.' },
        { q: '근거리 챌린지를 하려면 상대방도 앱이 있어야 하나요?', a: '네, 참가자 모두 제이드아이 앱이 설치되어 있어야 합니다. Android와 iOS 간 크로스플랫폼 연결을 지원합니다!' },
        { q: '스마트워치가 꼭 필요한가요?', a: '아니요! 스마트폰만으로도 걸음수, 운동 기록 등 대부분의 기능을 이용할 수 있어요. 스마트워치가 있으면 심박수 등 더 정밀한 데이터를 활용할 수 있습니다.' },
        { q: '해외에서도 사용할 수 있나요?', a: '네! 전 세계 어디서든 사용 가능합니다.' },
    ];

    let openFaqIndex = $state<number | null>(null);

    function toggleFaq(index: number) {
        openFaqIndex = openFaqIndex === index ? null : index;
    }
</script>

<section id="guide" class="guide-section">
    <div class="guide-inner">
        <h2 class="guide-title">시작하기 — 이렇게 쉬워요!</h2>

        <!-- Guides Accordion -->
        <div class="accordion">
            {#each guides as guide, i}
                <div class="accordion-item" class:open={openIndex === i}>
                    <button class="accordion-header" onclick={() => toggle(i)}>
                        <span class="accordion-label">{guide.title}</span>
                        <svg
                            width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="accordion-arrow"
                            class:rotated={openIndex === i}
                        >
                            <path d="m6 9 6 6 6-6" />
                        </svg>
                    </button>
                    {#if openIndex === i}
                        <div class="accordion-body">
                            <pre class="accordion-text">{guide.content}</pre>
                        </div>
                    {/if}
                </div>
            {/each}
        </div>

        <!-- FAQ Section -->
        <div class="faq-block">
            <h3 class="faq-title">자주 묻는 질문</h3>
            <div class="accordion">
                {#each faqs as faq, i}
                    <div class="accordion-item" class:open={openFaqIndex === i}>
                        <button class="accordion-header" onclick={() => toggleFaq(i)}>
                            <span class="accordion-label">Q. {faq.q}</span>
                            <svg
                                width="18" height="18" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="accordion-arrow"
                                class:rotated={openFaqIndex === i}
                            >
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        {#if openFaqIndex === i}
                            <div class="accordion-body">
                                <p class="accordion-text">{faq.a}</p>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>

        <div class="guide-more">
            <a href="/guide" class="guide-more-link">
                전체 가이드 보기
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                </svg>
            </a>
            <a href="/guide/nearby-challenge-guide" class="guide-more-link">
                근거리 협동 챌린지 가이드
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                </svg>
            </a>
            <a href="/guide/gyeongdo-guide" class="guide-more-link">
                경찰과 도둑 룰 총정리
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                </svg>
            </a>
            <a href="/guide/manbogi-guide" class="guide-more-link">
                만보기 어플 고르는 법
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                </svg>
            </a>
        </div>
    </div>
</section>

<style>
    .guide-section {
        padding: 5rem 1.5rem;
        background: var(--landing-bg-alt, #F8F9FA);
    }

    .guide-inner {
        max-width: 48rem;
        margin: 0 auto;
    }

    .guide-title {
        font-size: clamp(1.8rem, 4vw, 2.5rem);
        font-weight: 700;
        text-align: center;
        color: var(--landing-text, #1A1A1A);
        margin: 0 0 3rem;
    }

    /* Accordion */
    .accordion {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .accordion-item {
        background: #fff;
        border: 1px solid rgba(30, 92, 58, 0.08);
        border-radius: 12px;
        overflow: hidden;
        transition: border-color 0.2s;
    }

    .accordion-item.open {
        border-color: rgba(30, 92, 58, 0.2);
    }

    .accordion-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1rem 1.25rem;
        background: transparent;
        border: none;
        cursor: pointer;
        text-align: left;
    }

    .accordion-label {
        font-size: 0.95rem;
        font-weight: 600;
        color: var(--landing-text, #1A1A1A);
    }

    .accordion-arrow {
        color: var(--landing-text-sub, #666666);
        transition: transform 0.3s;
        flex-shrink: 0;
    }

    .accordion-arrow.rotated {
        transform: rotate(180deg);
    }

    .accordion-body {
        padding: 0 1.25rem 1.25rem;
        animation: fadeIn 0.2s ease;
    }

    .accordion-text {
        font-size: 0.88rem;
        color: var(--landing-text-sub, #666666);
        line-height: 1.8;
        white-space: pre-wrap;
        font-family: inherit;
        margin: 0;
    }

    /* FAQ */
    .faq-block {
        margin-top: 3rem;
    }

    .faq-title {
        font-size: 1.3rem;
        font-weight: 700;
        text-align: center;
        color: var(--landing-text, #1A1A1A);
        margin: 0 0 1.5rem;
    }

    /* Guide More Link */
    .guide-more {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.75rem 2rem;
        margin-top: 2rem;
    }

    .guide-more-link {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: var(--landing-primary, #1E5C3A);
        text-decoration: none;
        transition: opacity 0.2s;
    }

    .guide-more-link:hover {
        opacity: 0.7;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @media (min-width: 768px) {
        .guide-section {
            padding: 6rem 2.5rem;
        }
    }
</style>
